import type { PlanTab } from "./shared";
import type { Persona } from "../../Types/AccountPlan";

/** Where opening an account takes a persona: a tab, plus the read-only briefing view. */
export interface PlanLanding {
  tab: PlanTab;
  /** AE/CSM read a published briefing as their own page (no preview banner). */
  view?: "briefing";
}

/**
 * The one landing rule (spec NAV-01), shared by the plan page's default tab and
 * the My Accounts row click so the two can't drift:
 * - sponsor: the briefing, always;
 * - AE/CSM, no plan yet: Plan, where the upload is;
 * - AE/CSM, nothing usable yet (the first upload is still being read, or every
 *   upload so far stopped): Plan, where the progress or the problem is (F-UF-F09);
 * - AE/CSM, the current version waits on Confirm plan: Confirm plan (Phase 2);
 * - AE/CSM, plan but not published (no draft, draft or in review): Review briefing;
 * - AE/CSM, published: the read-only briefing (view=briefing).
 * Nobody lands on an already-done Publish step. This replaces the 2026-09-28
 * "everyone opens on the briefing" rule, which sent AE/CSM to the sponsor
 * layout before there was anything reviewed to read (Sushant, 2026-10-19).
 */
export const planLanding = (
  persona: Persona,
  state: {
    hasPlan: boolean;
    published: boolean;
    toConfirm?: boolean;
    /** No version has finished reading yet (no current version). */
    reading?: boolean;
  }
): PlanLanding => {
  if (persona === "ES") return { tab: "sponsor" };
  if (!state.hasPlan) return { tab: "plan" };
  if (state.reading && !state.published) return { tab: "plan" };
  if (state.toConfirm) return { tab: "viewer" };
  return state.published
    ? { tab: "sponsor", view: "briefing" }
    : { tab: "sponsor" };
};
